import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import './index.scss'
import BeginBulkAction from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/BeginBulkAction'
import RelinquishmentBulkAction from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/RelinquishmentBulkAction'
import DocumentBulkAction from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/DocumentBulkAction'
import AmendmentBulkAction from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction/AmendmentBulkAction'
import { OverclaimBulkActionType } from '@App/stores/overclaim/overclaim-search-bulk-action-store'

const OverclaimBulkAction = () => {
    const { overclaimSearchBulkActionStore } = useContext(StoresContext)

    return (
        <div className="overclaim-bulk-action-control-wrapper">
            {overclaimSearchBulkActionStore.activeBulkAction === OverclaimBulkActionType.Relinquishment && (
                <RelinquishmentBulkAction />
            )}
            {overclaimSearchBulkActionStore.activeBulkAction === OverclaimBulkActionType.DocumentUpload && (
                <DocumentBulkAction />
            )}
            {overclaimSearchBulkActionStore.activeBulkAction === OverclaimBulkActionType.AmendmentSelection && (
                <AmendmentBulkAction />
            )}
            {overclaimSearchBulkActionStore.activeBulkAction === null && <BeginBulkAction />}
        </div>
    )
}

export default observer(OverclaimBulkAction)
